const t = { last_updated: "Ultimo aggiornamento", Series_type: "Serie", "How to guide_type": "Guida", FAQ_type: "Predefinita" }, e = {
  articles: t
};
export {
  t as articles,
  e as default
};
//# sourceMappingURL=help-center-knowledge-anatomies31.js.map
